<template lang='pug' src='./getting-started.pug'></template>

<script>
import api from 'api'
import axios from 'axios'
import Loader from 'components/loader/loader'
import HeroGettingStarted from 'components/hero/getting-started/hero-getting-started'
import Finance from 'components/custom/custom-finance/custom-finance'
import PatientForms from 'components/custom/custom-patient-forms/custom-patient-forms'
import FooterMain from 'components/footer/footer-main'

export default {
  name: 'GettingStarted',
  data: () => {
    return {
      name: 'getting-started',
      props: {},
      message: 'GettingStarted',
      videosource: [],
      loading: true
    }
  },
  created () {
    this.loading = true
    axios.get(api + '/acf/v3/pages/77 ')
      .then(response => {
        this.props = response.data.acf
        this.loading = false
        this.videosource.push(response.data.acf.promo_video_mp4)
        this.videosource.push(response.data.acf.promo_video_webm)
      })
      .catch(e => {
        this.errors.push(e)
        console.log(this.errors.push(e))
        console.log(e)
      })
  },
  components: {
    Loader,
    HeroGettingStarted,
    Finance,
    PatientForms,
    FooterMain
  }
}
</script>



// WEBPACK FOOTER //
// getting-started.vue?79730d10